import { apiClient } from '../_helpers';
const apiPath = 'recipeComments/';
export const commentService = {
    get,
    add,
    edit,
    remove
};
async function get(params) {
    try {
        const response = await apiClient(`recipes/${params.recipeId}/comments`)
            .get();
        return response.data;
    } catch (error) {
        return error;
    }
}
async function add(params) {
    try {
        const response = await apiClient(apiPath)
            .post('', `${JSON.stringify(params)}`);
            return response.data;
    } catch (error) {
        return error;
    }
}
async function edit(params) {
    try {
        const response = await apiClient(`${apiPath}${params.id}`)
            .put('', `${JSON.stringify(params)}`);
            return response.data;
    } catch (error) {
        return error;
    }
}
async function remove(id) {
    try {
        const response = await apiClient(`${apiPath}${id}`)
            .delete();
        return response.data;
    } catch (error) {
        return error;
    }
}